var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRegularMark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 49,
    viewBox: "0 0 35 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_83_6871)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4604 34.22C26.6062 34.22 34.0204 26.8058 34.0204 17.66C34.0204 8.51414 26.6062 1.09998 17.4604 1.09998C8.31455 1.09998 0.900391 8.51414 0.900391 17.66C0.900391 26.8058 8.31455 34.22 17.4604 34.22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.49 2.8574e-06C12.8504 0.00265403 8.40182 1.84757 5.1221 5.12917C1.84237 8.41077 -7.57478e-07 12.8604 0 17.5C0 27.16 17.49 48.05 17.49 48.05C17.49 48.05 35 27.16 35 17.5C35 15.201 34.547 12.9246 33.6669 10.8007C32.7869 8.67688 31.4969 6.74725 29.8708 5.1221C28.2447 3.49694 26.3144 2.20811 24.19 1.32924C22.0657 0.450371 19.789 -0.00131084 17.49 2.8574e-06ZM17.49 32.17C14.5857 32.172 11.7461 31.3124 9.33047 29.7001C6.91482 28.0878 5.0317 25.7952 3.91937 23.1124C2.80703 20.4296 2.51548 17.4771 3.08159 14.6285C3.6477 11.78 5.04604 9.16332 7.09968 7.10968C9.15331 5.05604 11.77 3.6577 14.6185 3.09159C17.4671 2.52548 20.4196 2.81703 23.1024 3.92937C25.7852 5.0417 28.0778 6.92482 29.6901 9.34047C31.3024 11.7561 32.162 14.5957 32.16 17.5C32.16 19.4265 31.7805 21.3341 31.0433 23.114C30.3061 24.8938 29.2255 26.511 27.8633 27.8733C26.501 29.2355 24.8838 30.3161 23.104 31.0533C21.3241 31.7906 19.4165 32.17 17.49 32.17Z",
    fill: "#E9353E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2702 18.0901L24.7502 14.8301H19.2102L17.5002 9.56006L15.7802 14.8301H10.2402L14.7202 18.0901L13.0102 23.3601L17.4902 20.1001L21.9802 23.3601L20.2702 18.0901Z",
    fill: "#E9353E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_83_6871"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.99,
    height: 48.05,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegularMark);
export default __webpack_public_path__ + "static/media/RegularMark.6f5624d8cd765865c9c58eff44018df7.svg";
export { ForwardRef as ReactComponent };